<template>
    <basic-container>
        <avue-form style="height:2.5rem;" :option="searchFromOption" :search.sync="search" ref="searchForm" v-model="searchForm">
            <template slot="communityGroup">
               
            <el-select style="width: 100%" v-model="searchForm.communityGroup" @change="communityGroupChangeHandler">
              <el-option
                v-for="item in communityGroupList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
            </template>
            <template slot="communityId">
               
                <avue-input-tree 
                    node-key="id"
                    :props="defaultProps"
                    default-expand-all 
                    v-model="searchForm.communityId" 
                    placeholder="请选择小区" 
                    type="select" 
                    @change="communityIdChange"
                    :dic="communityList"
                >
                </avue-input-tree>
            </template>
            <template slot="buildingId">
               
                
                <avue-input-tree 
                    node-key="value"
                    ref="buildingIdSelect"
                    :props="defaultPropsBuilding"
                    default-expand-all 
                    v-model="searchForm.buildingId" 
                    placeholder="请选择楼栋/单元" 
                    type="select" 
                    @change="buildingIdChange"
                    :dic="buildingList"
                >
                </avue-input-tree>
            </template>
            <template slot="targetId">
            

                
                <avue-input-tree 
                    node-key="value"
                    :props="defaultPropsRoom"
                    default-expand-all 
                    v-model="searchForm.targetId" 
                    placeholder="请选择房号" 
                    type="select" 
                    @change="targetIdChange"
                    :dic="targetList"
                >
                </avue-input-tree>
            </template>
        </avue-form>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="收费" name="first" >
                <FeeContainer ref="feeContainer" :targetId.sync="searchForm.targetId"/>
            </el-tab-pane>
            <el-tab-pane label="临时收费" name="second" style="overflow:scroll;height: 600px;">
                <TempFeeContainer ref="tempFeeContainer" :targetId.sync="searchForm.targetId"/>
            </el-tab-pane>
            <el-tab-pane label="收费记录" name="third" style="overflow:scroll;height: 600px;">
                <ClientContainer ref="clientContainer" :targetId.sync="searchForm.targetId"/>
            </el-tab-pane>
        </el-tabs>
    </basic-container>
</template>

<script>
import FeeContainer from "./tab-container/fee";
import TempFeeContainer from "./tab-container/temp-fee";
import ClientContainer from "./tab-container/client";
import {
    loadRoomTree1,
    loadBuildingList,
    loadRoomList,
    getArrearsExtendtion,
    getDict,
    getCommunityGroupList
} from '@/api/charge/charge-pay';
export default {
    components: { FeeContainer,TempFeeContainer,ClientContainer },
    data() {
      return {
          search:{},
          communityGroupList:[],
        defaultProps:{
            children: 'children',
            label: 'title'
        },
        defaultPropsBuilding:{
            children: 'children',
            label: 'label'
        },
        defaultPropsRoom:{
            children: 'children',
            label: 'label'
        },
        searchForm:{},
        communityList:[],
        buildingList:[],
        targetList:[],
        activeName: 'first',
        subjectList:[],
      };
    },
    computed: {


       searchFromOption(){
         return{
            menuBtn:false,
            column: [{
                        label: "小区分组",
                        prop: "communityGroup",
                        type: "select",
                        formslot:true,
                        span: 6,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择小区分组",
                            trigger: "change"
                        }],
                    },{
                        label: "小区名称",
                        prop: "communityId",
                        type: "select",
                        formslot:true,
                        span: 6,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择小区名",
                            trigger: "change"
                        }],
                    },{
                        label: "楼栋/单元",
                        prop: "buildingId",
                        type: "select",
                        formslot:true,
                        span: 6,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择楼栋/单元名",
                            trigger: "blur"
                        }],
                    },{
                        label: "房号",
                        prop: "targetId",
                        type: "select",
                        formslot:true,
                        span: 6,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择房号",
                            trigger: "blur"
                        }],
                    },
                    // {
                    //     label: "户主",
                    //     prop: "householderName",
                    //     span: 6,
                    //     maxlength: 3,
                    //     disabled:true,
                    //     rules: [{
                    //         required: true,
                    //         message: "请输入用户名",
                    //         trigger: "blur"
                    //     }],
                    // },{
                    //     label: "欠缴总额",
                    //     prop: "arrears2",
                    //     disabled:true,
                    //     span: 6,
                        
                    //     rules: [{
                    //         required: true,
                    //         message: "请输入用户名",
                    //         trigger: "blur"
                    //     }],
                    // }
                    ]
            }



        }
    },
    created(){
        getCommunityGroupList().then((res)=>{
            this.communityGroupList = res.data;
            console.log("getCommunityGroupList=============>",res.data);
            this.searchForm.communityGroup = res.data[0].dictKey;
            loadRoomTree1({communityGroup:res.data[0].dictKey}).then(({ data }) => {
                this.communityList = data;
                if(data.length>0){
                    this.searchForm.communityId = data[0].id
                }
                console.log(data);
            });
        });
        this.getSubjectListHandlerAction();
    },
    methods: {
        communityGroupChangeHandler(val){
            
            loadRoomTree1({communityGroup:val}).then(({ data }) => {
                this.communityList = data;
                if(data.length>0){
                    this.searchForm.communityId = data[0].id
                }
                console.log(data);
            });
        },
        getSubjectListHandlerAction(){
            // getSubjectList().then((res)=>{
            getDict({code:'fee_item_type'}).then((res)=>{
                console.log(res);
                this.subjectList = res.data;
            })
        },
        handleClick(tab, event) {
            console.log(tab, event);
            console.log(this.searchForm.targetId,tab.name);
            if(tab.name==='first'){
                this.$refs.feeContainer.resetTableStyle()
            }
            if(tab.name==='second' && this.searchForm.targetId){
                this.$refs.tempFeeContainer.getFeeTypeList(this.searchForm.targetId);
            }
            if(tab.name==='third' && this.searchForm.targetId){
                console.log('third==============>');
                this.$refs.clientContainer.getPayBillListHandler(this.searchForm.targetId,true);
            }
        },
        communityIdChange(val){
            this.$refs.feeContainer.subjectDisabled();
            loadBuildingList({ propertyId: val }).then(({ data }) => {
                console.log(data);
                this.buildingList = data;
                this.targetList = [];
                this.searchForm.buildingId = '';
                this.searchForm.targetId = '';
                this.searchForm.arrears = '';
                this.searchForm.householderName = '';
            });
      },
      buildingIdChange(val){
          if(!val){
              return;
          }
                setTimeout(()=>{
                    //   console.log(this.$refs.searchForm);
                    this.$refs.searchForm.validateField('buildingId',(msg,valid,done)=>{
                        console.log(msg,valid,done);
                        done;
                    });
                })
        this.$refs.feeContainer.subjectDisabled();
        loadRoomList({ propertyId: val }).then(({ data }) => {
            console.log(data);
            this.targetList = data;
            this.searchForm.targetId = '';
                this.searchForm.arrears = '';
                this.searchForm.householderName = '';
        });
      },
      targetIdChange(val){
        this.$refs.tempFeeContainer.clearData()
        //   this.$refs.buildingIdSelect.blur();
          console.log(val);
          if(!val){
              return;
          }
                setTimeout(()=>{
                    //   console.log(this.$refs.searchForm);
                    
                    this.$refs.searchForm.validateField('targetId',(msg,valid,done)=>{
                        console.log(msg,valid,done);
                        done;
                    });
                })
          let targetName = '';
          this.targetList.forEach((ele,index)=>{
              if(ele.value === val){
                targetName = ele.label;
              }
          });
          this.$refs.feeContainer.getSubjectListHandler();
          this.$refs.feeContainer.subjectActive();
          setTimeout(()=>{
              this.$refs.clientContainer.getPayBillListHandler('',true);
          })
        //   loadZhxx({roomId:val}).then(({ data }) => {
                // this.searchForm.householderName = data[0].householder;
                // this.$refs.feeContainer.loadBillList(val,targetName,'',data[0].householder);
                // this.$refs.tempFeeContainer.getFeeTypeList(val,targetName,'',data[0].householder);
            // });
        //   getArrears({targetId:val}).then(({ data }) => {
        //         this.searchForm.arrears = data;
        //     });
        getArrearsExtendtion({roomId:val}).then(({ data }) => {
            if(data.householdList.length>0){
                // this.searchForm.arrears = data.sumOfAmount;
                this.searchForm.arrears = this.tool.money_format_allowvoid(data.sumOfAmount);
                this.searchForm.householderName = data.householdList[0].householdName;
                this.$refs.feeContainer.loadBillList(val,targetName,'',data.householdList[0].householdName,data.householdList[0].linkPhone, data.floorAge, data.fullName);
                this.$refs.tempFeeContainer.getFeeTypeList(val,targetName,'',data.householdList[0].householdName);
            }else{
                this.searchForm.arrears = '';
                this.searchForm.householderName = '';
                this.$refs.feeContainer.loadBillList(val,targetName,'','','', data.floorAge, data.fullName);
                this.$refs.tempFeeContainer.getFeeTypeList(val,targetName,'','');
            }
                
            }).catch((err) => {
                this.searchForm.arrears = '';
                this.searchForm.householderName = '';
                this.$refs.feeContainer.loadBillList(val,targetName,'','');
                this.$refs.tempFeeContainer.getFeeTypeList(val,targetName,'','');
            console.log("err==>", err);
          });
            // this.subjectList.forEach((ele,index)=>{
            //     getCouponList({
            //         subjectId:ele.id,
            //         targetId:val,
            //         resourceType:'1'
            //     }).then(({data})=>{
            //         console.log("getCouponList=====>",data);
            //     });
            // });
          console.log(this.$refs.feeContainer);
        //   this.$refs.feeContainer.loadBillList(val,targetName);
      },
    }
}
</script>

<style>

</style>